import { ExpandMore } from '@mui/icons-material';
import { Accordion, AccordionDetails, Typography, useEventCallback } from '@mui/material';
import { AccordionSummary } from 'shell/components/shared/summary-accordion';
import { useEffect, useRef, useState } from 'react';
import { FormikErrors, FormikTouched, useFormikContext } from 'formik';
import { ReleaseIdCard } from 'front-office/view-models/release-id-card';
import { Document } from 'front-office/view-models/release-id-card/document';
import IdentityCardForm from './identity-card-form';

const DocumentForm = (): React.ReactElement => {
  const formContext = useFormikContext<ReleaseIdCard>();

  const [openIdentityCard, setOpenIdentityCard] = useState(true);

  const ref = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    ref.current?.scrollIntoView();
  }, []);

  const onChangeIdentityCard = useEventCallback(
    (key: keyof Document, value: Document[keyof Document]) => {
      const newDocument = {
        ...formContext.values.document,
        [key]: value,
      };

      formContext.setFieldValue('document', newDocument);
    }
  );

  const onChangeValuesIdentityCard = useEventCallback((values: Document) => {
    const newDocument = {
      ...formContext.values.document,
      ...values,
    };

    formContext.setFieldValue('document', newDocument);
  });

  return (
    <>
      <Accordion
        expanded={openIdentityCard}
        onChange={() => {
          setOpenIdentityCard(!openIdentityCard);
        }}
        ref={ref}
      >
        <AccordionSummary
          aria-controls="panel-control-data-content"
          id="panel-control-data-header"
          expandIcon={<ExpandMore />}
        >
          <Typography>Carta di identità</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <IdentityCardForm
            onChange={onChangeIdentityCard}
            onChangeValues={onChangeValuesIdentityCard}
            birthday={formContext.values.registryOffice?.generality?.birthDate}
            values={formContext.values.document as Document}
            errors={formContext.errors.document as FormikErrors<Document>}
            touched={formContext.touched.document as unknown as FormikTouched<Document>}
            isResident={formContext.values.isResident}
          />
        </AccordionDetails>
      </Accordion>
    </>
  );
};

DocumentForm.displayName = 'Release id card form - document component';

export default DocumentForm;
